import { resolveAssetPath } from "../../shared/utilities/assets";
import type { SectionRenderProps } from "../renderer/types";

export function StorySection({ data, copy }: SectionRenderProps) {
  if (!data.story.enabled) return null;
  return (
    <section className="story section-inner" id="story">
      <div className="story-bg" aria-hidden="true"><span /><span /><span /><span /><span /></div>
      <div className="section-heading reveal is-visible">
        <p className="eyebrow">{copy.storyEyebrow}</p>
        <h2 data-editor-section="story" data-editor-field="story.title">{data.story.title}</h2>
        <p className="story-lead" data-editor-section="story" data-editor-field="story.introduction">{data.story.introduction}</p>
      </div>
      <div className="story-flow">
        {data.story.items.slice().sort((a, b) => a.order - b.order).map((item) => {
          const itemIndex = data.story.items.findIndex((candidate) => candidate.id === item.id);
          return <article className="story-moment reveal is-visible" key={item.id} data-editor-section="story" data-editor-field={`story.items.${itemIndex}`}>
            <span data-editor-section="story" data-editor-field={`story.items.${itemIndex}.date`}>{item.date}</span>
            <div>
              {item.image ? <img className="story-image" src={resolveAssetPath(item.image)} alt={item.title} /> : null}
              <h3 data-editor-section="story" data-editor-field={`story.items.${itemIndex}.title`}>{item.title}</h3>
              <p data-editor-section="story" data-editor-field={`story.items.${itemIndex}.description`}>{item.description}</p>
            </div>
          </article>;
        })}
      </div>
    </section>
  );
}
